import { createAsyncThunk } from '@reduxjs/toolkit';

interface Params {
  title: string;
  confirmBtn?: string;
  cancelBtn?: string;
  callback: (result: boolean) => void | Promise<void>;
}

interface Result {
  title: string;
  confirmBtn?: string;
  cancelBtn?: string;
  callback: (result: boolean) => void | Promise<void>;
}

export const confirmation = createAsyncThunk<Result, Params, { rejectValue: string }>(
  'ux/confirm',
  (params, { rejectWithValue }) => {
    try {
      return {
        title: params.title,
        confirmBtn: params.confirmBtn,
        cancelBtn: params.cancelBtn,
        callback: params.callback,
      };
    } catch (e) {
      return rejectWithValue((e as Error).message);
    }
  }
);

export interface ResolveConfirmation {
  result: boolean;
}
